import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { pushDL } from './utils/trackingFrontaliere';

const PRO_ROUTE_CONFIG = [
  {
    match: /^\/account\/manage/,
    page_type: 'espace_pro',
    page_category: "Gestion de l'effectif",
  },
  {
    match: /^\/account\/wallet/,
    page_type: 'espace_pro',
    page_category: 'Compte de résultat',
  },
  {
    match: /^\/account\/coverage/,
    page_type: 'espace_pro',
    page_category: 'Garanties & contrats',
  },
  {
    match: /^\/account\/teams/,
    page_type: 'espace_pro',
    page_category: 'Équipes',
  },
  {
    match: /^\/account\/help/,
    page_type: 'espace_pro',
    page_category: 'Aide',
  },
];

const EMPLOYEE_ROUTE_CONFIG = [
  {
    match: /^\/account\/myrefunds/,
    page_type: 'espace_perso',
    page_category: 'Mes remboursements',
  },
  {
    match: /^\/account/,
    page_type: 'espace_perso',
    page_category: 'Accueil',
  },
  {
    match: /^\/account\/refund/,
    page_type: 'espace_perso',
    page_category: 'Demander un remboursement',
  },
  {
    match: /^\/account\/prices/,
    page_type: 'espace_perso',
    page_category: 'Mes garanties',
  },
  {
    match: /^\/account\/quote/,
    page_type: 'espace_perso',
    page_category: 'Je fais analyser un devis',
  },
  {
    match: /^\/account\/rightholders/,
    page_type: 'espace_perso',
    page_category: 'Mes bénéficiaires',
  },
  {
    match: /^\/account\/personal_info/,
    page_type: 'espace_perso',
    page_category: 'Mes coordonnées',
  },
  {
    match: /^\/account\/teleconsultation/,
    page_type: 'espace_perso',
    page_category: 'Téléconsultation',
  },
  {
    match: /^\/account\/documents/,
    page_type: 'espace_perso',
    page_category: 'Mes documents',
  },
  {
    match: /^\/account\/advisor/,
    page_type: 'espace_perso',
    page_category: 'Contacter mon conseiller',
  },
];

const ROUTE_CONFIG = [
  {
    match: /^\/$/,
    page_type: 'home',
    page_category: 'site_vitrine',
  },
  {
    match: /^\/subscribe/,
    page_type: 'formulaire',
    page_category: 'contrat',
  },
  ...PRO_ROUTE_CONFIG,
  ...EMPLOYEE_ROUTE_CONFIG,
];

function getPageConfig(pathname) {
  return (
    ROUTE_CONFIG.find((route) => route.match.test(pathname)) || {
      page_type: 'unknown',
      page_category: 'unknown',
    }
  );
}

function PageViewTracker() {
  const location = useLocation();

  const pageConfig = useMemo(() => {
    return getPageConfig(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    pushDL('page_view', {
      website_language: 'fr',
      page_type: pageConfig.page_type,
      page_category: pageConfig.page_category,
      article_name: null,
      article_type: null,
      url: location.pathname,
    });
  }, [location.pathname, pageConfig]);

  return null;
}

export default PageViewTracker;
